<template>
  <div class="teacher">
    <div class="detail-card__teacher__item" v-for="(item, index) in data" :key="index">
      <div
        class="teacher__avater"
        :style="`background-image:url('${item.avatar}')`"
      ></div>
      <div class="teacher__info">
        <p class="teacher__info__des">{{ title }}</p>
        <p class="teacher__info__name">{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    leftNum: {
      type: Number,
      default: 0
    },
    excTeacherCourse: {
      type: Number,
      default: -1 // -1:授课老师（中文老师|英文老师），0:辅导老师，1:专属老师
    },
    isCounselorTeacher: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {
    isExcTeacherCourse() {
      return (
        Number(this.isCounselorTeacher) === 1 &&
        this.excTeacherCourse &&
        this.excTeacherCourse === 1
      )
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@include b(detail-card) {
  @include e(teacher) {
    @include e(item) {
      position: relative;
      margin: 0px 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
}
@include b(teacher) {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  @include e(avater) {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: cover;
    border-radius: 100%;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    border: 1px solid #f1f1f1;
  }
  @include e(info) {
    display: inline-block;
    padding-left: 4px;
    & > p {
      font-size: 12px;
      line-height: 16px;
    }
    @include e(des) {
      color: #666666;
    }
    @include e(name) {
      color: #333333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/DialogCardTeacher.vue